import React from 'react';
import { AlertCircle } from 'lucide-react';
export function Hook() {
  return <section className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-88">
      <div className="mx-auto max-w-3xl text-center" data-id="element-89">
        <div className="mb-8 flex justify-center" data-id="element-90">
          <div className="rounded-full bg-red-500/10 p-4" data-id="element-91">
            <AlertCircle className="h-10 w-10 text-red-500" data-id="element-92" />
          </div>
        </div>

        <h2 className="mb-8 text-3xl sm:text-4xl font-bebas text-white leading-tight" data-id="element-93">
          ¿Alguna vez has sentido ese nudo en el estómago cuando el vendedor del
          concesionario camina hacia ti con una cara de{' '}
          <span className="text-red-400" data-id="element-94">
            "lo siento, el banco no te aprobó"
          </span>
          ?
        </h2>

        <div className="space-y-6 text-lg text-slate-300 text-left" data-id="element-95">
          <p data-id="element-96">
            No es solo un rechazo financiero; se siente como un rechazo a tu
            esfuerzo, a tu familia y a tu futuro en este país.
          </p>
          <p className="font-medium text-white border-l-4 border-gold-400 pl-4 py-2 bg-navy-900/50 rounded-r-lg" data-id="element-97">
            Pero aquí está la verdad que los burós de crédito no quieren que
            sepas: Tu puntaje bajo no es un reflejo de quién eres, es
            simplemente el resultado de un sistema lleno de errores que tú
            puedes corregir hoy mismo.
          </p>
        </div>
      </div>
    </section>;
}